"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEvents = void 0;
class EventEvents {
    builder;
    constructor(builder) {
        this.builder = builder;
    }
    static event(builder) {
        return new EventEvents(builder);
    }
    addPart(part) {
        this.builder.addPart(part);
        return this;
    }
    toString() {
        return this.builder.toString();
    }
    get create() {
        return this.builder.addPart("create").toString();
    }
    get campaignRequest() {
        return this.builder.addPart("new_request_campaign").toString();
    }
    get wildcard() {
        return this.builder.wildcard;
    }
}
exports.EventEvents = EventEvents;
